import { render, staticRenderFns } from "./FamilyReferences.vue?vue&type=template&id=55fa5b88&"
import script from "./FamilyReferences.vue?vue&type=script&lang=js&"
export * from "./FamilyReferences.vue?vue&type=script&lang=js&"
import style0 from "./FamilyReferences.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports